import type { IconDefinition, IconName } from '@fortawesome/free-solid-svg-icons';

const prefix = 'fas';
const iconName = 'alert-severe' as IconName;
const width = 496;
const height = 512;
const ligatures: string[] = [];
const unicode = 'xxxx';
const svgPathData =
  'M 256.00391 86.759766 C 244.64132 86.759766 234.1578 92.759319 228.39648 102.60156 L 55.558594 397.07031 C 49.797278 406.91255 49.717139 419.23593 55.398438 429.1582 C 61.079736 439.08047 71.721449 445.24023 83.164062 445.24023 L 428.84375 445.24023 C 440.28637 445.24023 450.92807 439.08047 456.60938 429.1582 C 462.29067 419.23593 462.29055 406.99257 456.44922 397.07031 L 283.60938 102.60156 C 277.84806 92.759309 267.3665 86.759766 256.00391 86.759766 z M 256 160 C 269.29999 160 280 170.70001 280 184 L 280 296 C 280 309.29999 269.29999 320 256 320 C 242.70001 320 232 309.29999 232 296 L 232 184 C 232 170.70001 242.70001 160 256 160 z M 256 352 C 273.67309 352 288 366.3269 288 384 C 288 401.6731 273.67309 416 256 416 C 238.32691 416 224 401.6731 224 384 C 224 366.3269 238.32691 352 256 352 z';

export const alertSevere: IconDefinition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};
